module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload",
    class: _vm.fileInfo ? 'disabled' : ''
  }, [_c('a', {
    staticClass: "a-upload",
    class: _vm.fileInfo ? 'disabled' : '',
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Choose File")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.fileInfo,
      "id": "file",
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaebf06e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/vue-upload-file.vue
// module id = 606
// module chunks = 4 5 6